import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { formatCurrency } from '@lc/legacy/src/Helpers';
import { booking, payment } from 'helpers';
import { useTranslation } from 'react-i18next';
import EPeriodType from '@lc/legacy/src/enum/EPeriodType';

const BookingSummary = ({ classes, data, coupon }) => {
  const { t } = useTranslation(['booking', 'search', 'translations']);

  const {
    totalWithDiscount,
    totalWithoutDiscount,
    totalDiscount,
    discount,
    totalPeriods,
  } = payment.calculatePrice(booking.getPeriods(data.id), data.price, data.discounts, coupon);

  const summary = {
    valueByPeriod: formatCurrency(data.price),
    periods: {
      total: totalPeriods,
      value: formatCurrency(totalWithoutDiscount),
    },
    discount: {
      total: `${discount}%`,
      value: formatCurrency(totalDiscount),
    },
    total: formatCurrency(totalWithDiscount),
  };

  return (
    <Grid container spacing={0}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow className={`${classes.boderNone} ${classes.small}`}>
                <TableCell padding="checkbox">
                  {summary.valueByPeriod}/{data.period_type !== EPeriodType.HOURS ? t('search:period') : t('translations:hour')}
                </TableCell>
                <TableCell align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classes.small}>
                <TableCell padding="checkbox" scope="row" style={{ paddingBottom: '10px' }}>
                  X {summary.periods.total}
                </TableCell>
                <TableCell padding="checkbox" align="right">
                  {summary.periods.value}
                </TableCell>
              </TableRow>
              {discount > 0 && (
                <TableRow className={`${classes.discount} ${classes.small}`}>
                  <TableCell scope="row">
                    {t('totalDiscounts', { value: summary.discount.total })}
                  </TableCell>
                  <TableCell align="right">{summary.discount.value}</TableCell>
                </TableRow>
              )}
              <TableRow className={`${classes.boderNone} ${classes.small}`}>
                <TableCell scope="row" style={{ paddingTop: '10px' }}>
                  {t('total')}:
                </TableCell>
                <TableCell align="right">{summary.total}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
  );
};

BookingSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  coupon: PropTypes.bool
};

BookingSummary.defaultProps = {
  coupon: false
};

const styles = () => ({
  boderNone: {
    '& > td, th': {
      border: 'none',
      fontWeight: 'bold',
    },
  },
  discount: {
    '& > td': {
      color: '#34BA92',
    },
  },
  small: {
    '& > td, th': {
      '@media (max-width:320px)': {
        fontSize: '12px',
      },
    },
  },
});

export default withStyles(styles)(BookingSummary);
